import type { CustomParamsSerializer } from 'axios';

export const standardArrayHandlingAxios: CustomParamsSerializer = (params) => {
  const searchParams = new URLSearchParams();

  for (const key in params) {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(key, item);
      });
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }

  return searchParams.toString();
};
